import React, { createContext, useEffect, useState } from "react";
import contentObj from "../content/contentObj";
import useTranslator from "../CustomeHook/useTranslation";

export const TranslationContext = createContext();

const TranslationProvider = ({ children }) => {
	const [lang, setLang] = useState(
		JSON.parse(localStorage.getItem("lang"))?.code || "en"
	);
	const { translate } = useTranslator(lang);
	const [contentData, setContentData] = useState(contentObj);

	useEffect(() => {
		const cache = JSON.parse(localStorage.getItem("langCache")) || {};

		if (lang === "en") {
			if (cache[lang]) {
				setContentData(cache[lang]);
			} else {
				setContentData(contentObj);
			}
		} else {
			if (cache[lang]) {
				setContentData(cache[lang]);
			} else {
				const fetchData = async () => {
					try {
						const translations = await Promise.all(
							Object.values(contentObj).map(translate)
						);
						const translatedContent = Object.keys(
							contentObj
						).reduce((result, key, index) => {
							result[key] = translations[index];
							return result;
						}, {});
						setContentData(translatedContent);
						cache[lang] = translatedContent;
						localStorage.setItem(
							"langCache",
							JSON.stringify(cache)
						);
					} catch (error) {
						console.error("Translation API error:", error);
					}
				};
				fetchData();
			}
		}
	}, [lang]);

	return (
		<TranslationContext.Provider value={{ contentData, lang, setLang }}>
			{children}
		</TranslationContext.Provider>
	);
};

export default TranslationProvider;
